import animals from "./animals";
import fields from "./fields";
import plants from "./plants";
import nurturedImg from "src/assets/images/kwaii/nurtured.png";
import originImg from "src/assets/images/kwaii/origin.png";

export default { ...animals, ...fields, ...plants };

export const genMapping = {
  0: originImg,
  1: nurturedImg,
};

export const genNamesMapping = {
  0: "Origin",
  1: "Nurtured",
};
